import { useEffect, useState } from 'react';
import { resolveDisplayAssetUrl } from '../utils/api';

const EMPTY_MATERIALS = [];

const formatFileSize = (size) => {
  const bytes = Number(size);
  if (!Number.isFinite(bytes) || bytes <= 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.ceil(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const SessionMaterialsList = ({ materials = EMPTY_MATERIALS }) => {
  const [resolvedUrls, setResolvedUrls] = useState({});
  const [resolving, setResolving] = useState(false);

  useEffect(() => {
    let active = true;

    const resolveUrls = async () => {
      const entries = await Promise.all(
        materials.map(async (material, index) => {
          const url = await resolveDisplayAssetUrl(material?.url);
          return [index, url];
        }),
      );
      if (active) {
        setResolvedUrls(Object.fromEntries(entries));
        setResolving(false);
      }
    };

    setResolvedUrls({});
    if (materials.length > 0) {
      setResolving(true);
      resolveUrls();
    } else {
      setResolving(false);
    }

    return () => {
      active = false;
    };
  }, [materials]);

  if (materials.length === 0) {
    return <p className="text-sm text-gray-500">No materials uploaded.</p>;
  }

  return (
    <ul className="space-y-2">
      {materials.map((material, index) => {
        const resolvedUrl = resolvedUrls[index];
        const label = material.filename || `Material ${index + 1}`;
        return (
          <li
            key={`${material.url || label}-${index}`}
            className="flex items-center justify-between gap-3 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2"
          >
            <div className="min-w-0">
              <p className="truncate text-sm font-medium text-gray-800">
                {label}
              </p>
              {formatFileSize(material.size) && (
                <p className="text-xs text-gray-500">
                  {formatFileSize(material.size)}
                </p>
              )}
            </div>
            {resolvedUrl ? (
              <a
                href={resolvedUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="shrink-0 text-sm font-semibold text-brand-medium-blue hover:underline"
              >
                View
              </a>
            ) : resolving ? (
              <span className="shrink-0 text-xs text-gray-400">Loading…</span>
            ) : (
              <span className="shrink-0 text-xs text-gray-400">
                Unavailable
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default SessionMaterialsList;
